module.exports = __webpack_public_path__ + "static/media/rapidtest_logo.862c059f.png";